<template>
  <div
    class="vcore_input-group "
    :class="{ 'vcore_has-error': !!error, 'feedback-padding': !error }"
  >
    <label
      v-if="label"
      class="vcore_input-label"
      :class="{ 'vcore_input-label_optional': !required }"
      :style="{ color: labelColor }"
      :for="id | idFormat"
      :id="ariaLabelledBy | ariaFormat"
      >{{ label }}</label
    >
    <button v-if="popover" :ref="`${id}_label-icon` | idFormat" class="popover-trigger"
      aria-label="More info" type="button">
      <i class="vcore_icon icon-info"></i>
    </button>
    <Popover v-if="popover && popoverTarget"
             :placement="popover.placement"
             :target="popoverTarget"
             :title="popover.title"
             :content="popover.content"
             :id="popover.id"
             :turnOffTranslate="popover.turnOffTranslate"
    ></Popover>
    <div :class="size" :id="id | idFormat">
      <label v-for="option in options" :key="option.value">
        <input
          type="radio"
          :name="name || label"
          :value="option.value"
          :aria-invalid="`${!!error}`"
          :aria-required="`${required}`"
          :aria-errormessage="ariaErrorMessage"
          :checked="option.value === value"
          @change="handleRadio"
          @blur="$emit('blur')"
        />
        {{ option.text }}
      </label>
    </div>
    <span class="vcore_input-addon"> </span>
    <div
      class="vcore_input-feedback feedback-position"
      :id="errorId | idFormat"
      v-if="error"
      aria-live="assertive"
    >{{ error }}</div>
  </div>
</template>

<script>
import Popover from "./Popover";
export default {
  name: "Radio",
  props: {
    options: {
      type: Array,
      required: true,
      default: function() {return []}
    },
     popover: Object,
    label: String,
    name: String,
    value: {},
    placeholder: String,
    labelStyle: String,
    inputStyle: String,
    size: {
      default: ""
    },
    labelColor: String,
    maskOptions: Object,
    required: Boolean,
    error: String,
    formName: String
  },
   components: {    
    Popover
  },
  data() {
    return {
      content: this.value,
      popoverTarget: null
    };
  },
  computed: {
    id() {
      if (this.formName) {
        return `${this.formName}_${this.label}`;
      }
      return this.label;
    },

    ariaLabelledBy() {
      return `${this.id}--label`;
    },

    ariaErrorMessage() {
      return this.error ? this.$options.filters.idFormat(this.errorId) : undefined;
    },

    errorId() {
      return `${this.id}--error`;
    }
  },
  watch: {
    value() {
      this.content = this.value;
    }
  },
  methods: {
    handleRadio(event) {
      //console.log("input", event.target.value);
      this.$emit("input", event.target.value);
    }
  },
   mounted() {
    this.popoverTarget = this.$refs[`${this.$options.filters.idFormat(this.id)}_label-icon`];
  }
};

</script>

<style lang="scss" scoped>
select.vcore_input {
  &.small {
    height: 30px;
  }

  &.large {
    height: 50px;
  }
}

label:nth-child(2) {
  margin-left: 20px;
}

.vcore_select.large {
  &::before,
  &::after {
    line-height: 50px;
  }
}

.feedback-position {
  position: absolute;
}



.vcore_input-group {

  .vcore_input-label + button.popover-trigger {
    display: inline-block;
    color: $color_dark-blue;
    cursor: pointer;
    margin-left: 4px;

    .vcore_icon {
      font-size: 16px;
    }
  }
}

.popover-trigger {
  border-radius: 500px;
  border: none;
  background: none;
  width: fit-content;
  height: fit-content;
  padding: 0;
  margin-left: 4px;
}

.popover-trigger:focus-visible {
  outline: 2px solid black;
  outline-offset: 2px;
}
</style>
